import { API, constructApiUrl } from '../apis.config'
import { restApiClientBlob } from '../rest-api-client'

export const payBalance = async (id: number, amount: number) => {
  const response = await restApiClientBlob
    .url(constructApiUrl(API.enrollments.payBalance.url, { id }))
    .post({
      amount,
      returnUrl: `${import.meta.env.VITE_FRONTEND_URL}/client-personal-space/${id}/reservation/finalize-payment`
    })

  const url = URL.createObjectURL(response)
  window.location.href = url // Redirect the user to the generated HTML page
  return response
}
